import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getCollaboratorsList = store => store[NAME].collaboratorsList;
export const getPlansList = store => store[NAME].plansList;